module.exports = __webpack_public_path__ + "img/avida@2x.acf07dd.png";